module.exports = __webpack_public_path__ + "static/img/s.83889ab3.png";